import { useState } from "react";
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { STONKFUN_URL, TELEGRAM_URL, X_URL } from "@/lib/fronk";

const LINKS = [
  { href: "#chairman", label: "The Chairman" },
  { href: "#tubes", label: "The Tubes" },
  { href: "#staff", label: "The Staff" },
  { href: "#night-shift", label: "Night Shift" },
  { href: "#payroll", label: "Get On Payroll" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-[color:var(--hairline)] bg-[rgba(251,247,238,0.82)] backdrop-blur-md">
      <div className="mx-auto grid h-16 w-full max-w-[1600px] grid-cols-[1fr_auto] items-center px-4 sm:px-6 lg:grid-cols-[1fr_auto_1fr] lg:px-8 2xl:px-10">
        <a
          href="#top"
          className="flex items-center gap-3 justify-self-start whitespace-nowrap"
          data-testid="nav-wordmark"
        >
          <img
            src="/fronk/hero/fronk-wordmark-navy.webp"
            alt="FRONK wordmark"
            className="h-8 w-auto"
          />
          <span className="font-mono-ledger hidden text-[10px] uppercase tracking-[0.24em] text-[color:var(--ink-700)] sm:block">
            Toad Payroll Dept.
          </span>
        </a>

        <nav className="hidden items-center justify-self-center gap-5 lg:flex xl:gap-7">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="font-mono-ledger text-[11px] uppercase tracking-[0.18em] text-[color:var(--ink-800)] transition-colors hover:text-[color:var(--stamp-600)]"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center justify-self-end gap-2">
          <div className="hidden items-center gap-2 sm:flex">
            <a
              href={X_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="font-mono-ledger rounded-lg border border-[color:var(--ink-800)] px-3 py-2 text-[10px] uppercase tracking-[0.16em] text-[color:var(--ink-800)] transition-colors hover:border-[color:var(--stamp-600)] hover:text-[color:var(--stamp-600)]"
            >
              X
            </a>
            <a
              href={TELEGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="font-mono-ledger rounded-lg border border-[color:var(--ink-800)] px-3 py-2 text-[10px] uppercase tracking-[0.16em] text-[color:var(--ink-800)] transition-colors hover:border-[color:var(--stamp-600)] hover:text-[color:var(--stamp-600)]"
            >
              Telegram
            </a>
          </div>
          <Button
            asChild
            className="rounded-xl bg-[color:var(--stamp-600)] px-4 font-mono-ledger text-xs uppercase tracking-[0.14em] text-[color:var(--paper-0)] shadow-[var(--ink-smudge)] transition-colors hover:bg-[color:var(--stamp-500)] active:translate-y-[1px]"
            data-testid="nav-buy-button"
          >
            <a href={STONKFUN_URL} target="_blank" rel="noopener noreferrer">
              Buy $FRONK
            </a>
          </Button>

          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <Button
                variant="outline"
                size="icon"
                className="rounded-xl border-[color:var(--ink-800)] lg:hidden"
                data-testid="nav-menu-button"
                aria-label="Open menu"
              >
                <Menu className="h-5 w-5" />
              </Button>
            </SheetTrigger>
            <SheetContent
              side="right"
              className="w-72 border-l-2 border-[color:var(--ink-800)] bg-[color:var(--paper-0)]"
            >
              <div className="mt-8 flex flex-col gap-5">
                <img
                  src="/fronk/hero/fronk-wordmark-navy.webp"
                  alt="FRONK wordmark"
                  className="h-10 w-auto self-start"
                />
                {LINKS.map((l) => (
                  <a
                    key={l.href}
                    href={l.href}
                    onClick={() => setOpen(false)}
                    className="font-heading text-xl text-[color:var(--ink-900)] transition-colors hover:text-[color:var(--stamp-600)]"
                  >
                    {l.label}
                  </a>
                ))}
                <div className="grid grid-cols-2 gap-2 pt-2">
                  <Button asChild variant="outline" className="rounded-xl border-[color:var(--ink-800)]">
                    <a href={X_URL} target="_blank" rel="noopener noreferrer">
                      X
                    </a>
                  </Button>
                  <Button asChild variant="outline" className="rounded-xl border-[color:var(--ink-800)]">
                    <a href={TELEGRAM_URL} target="_blank" rel="noopener noreferrer">
                      Telegram
                    </a>
                  </Button>
                </div>
                <Button
                  asChild
                  className="mt-4 rounded-xl bg-[color:var(--stamp-600)] font-mono-ledger text-xs uppercase tracking-[0.14em] text-[color:var(--paper-0)] hover:bg-[color:var(--stamp-500)]"
                >
                  <a href={STONKFUN_URL} target="_blank" rel="noopener noreferrer">
                    Buy $FRONK on StonkFun
                  </a>
                </Button>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};
